export * from './getAllDonationFunds';
export * from './getDonationFund';
export * from './createDonationFund';
export * from './updateDonationFund';

export function fundMapper(fund) {
  return {
    id: fund.id,
    name: fund.name,
    description: fund.description,
    imageUrl: fund.image_url,
    totalDonationAmount: fund.total_donation_amount,
    isEnabled: fund.is_enabled,
    isDefault: fund.default,
    defaultAmountMonthly: fund.default_amount_monthly,
    defaultAmountYearly: fund.default_amount_yearly,
    amountMonthly2: fund.amount_monthly_2,
    amountYearly2: fund.amount_yearly_2,
    includeInAppPromotions: fund.include_in_app_promotions,
    // Cause Feed Item fields
    causeFeedItemEnabled: fund.cause_feed_item_enabled,
    causeFeedItemPlacement: fund.cause_feed_item_placement,
    causeFeedItemMediaUrl: fund.cause_feed_item_media_url,
    causeFeedItemMediaType: fund.cause_feed_item_media_type,
    causeFeedItemAudioUrl: fund.cause_feed_item_audio_url,
    causeFeedItemTargetEnabled: fund.cause_feed_item_target_enabled,
    causeFeedItemTargetAmount: fund.cause_feed_item_target_amount,
    causeFeedItemScheduleEnabled: fund.cause_feed_item_schedule_enabled,
    causeFeedItemStartsAt: fund.cause_feed_item_starts_at,
    causeFeedItemEndsAt: fund.cause_feed_item_ends_at,
    // Cause Feed Item Override fields
    causeFeedItemOverrideEnabled: fund.cause_feed_item_override_enabled,
    causeFeedItemTitle: fund.cause_feed_item_title,
    causeFeedItemDescription: fund.cause_feed_item_description,
    // Video thumbnail
    causeFeedItemVideoThumbnailUrl: fund.cause_feed_item_video_thumbnail_url,
  };
}
